var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"s-vstack"},[_vm._l((_vm.items),function(server,sindex){return _c('PersonCell',{key:sindex,attrs:{"server":server,"index":sindex,"isDecimal":_vm.isDecimal,"showWage":_vm.showWage}})}),_c('BottomActions',{attrs:{"items":_vm.items,"isDecimal":_vm.isDecimal,"showWage":_vm.showWage,"range":_vm.range}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }